// App.js
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

// 导入页面组件
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SolutionDetailPage from './pages/solutions/SolutionDetailPage';
import PaymentForm from './pages/PaymentForm';
import NotFoundPage from './pages/NotFoundPage';
import ProfilePage from './pages/ProfilePage'; // 导入 ProfilePage
import Navigation from './components/Navigation'; // 导入 Navigation 组件
import SubscriptionPage from './pages/SubscriptionPage'; // 导入 SubscriptionPage
import SubscriptionManagementPage from './pages/SubscriptionManagementPage'; // 导入 SubscriptionManagementPage
import AlipayReturnPage from './pages/AlipayReturnPage'; // Import AlipayReturnPage
import RegisterPage from './pages/RegisterPage';
import RequirementsPage from './pages/RequirementsPage'; // Import RequirementsPage
//css
// import { ThemeProvider, createTheme } from '@mui/material/styles'; //  导入 ThemeProvider 和 createTheme
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline'; //  导入 CssBaseline
import GoogleAuthLoadingPage from './pages/GoogleAuthLoadingPage'; //  Import GoogleAuthLoadingPage
import GithubAuthLoadingPage from './pages/GithubAuthLoadingPage'; //  Import GithubAuthLoadingPage

//  创建 Material UI 主题 (可选，可以自定义主题颜色、字体等)
const theme = createTheme({
  // 在这里自定义你的主题
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const getBrowserLanguage = () => {
  const lang = navigator.language || navigator.userLanguage; // 兼容不同浏览器
  if (lang == "zh" || lang == "zh-Hans" || lang== "zh-Hans-CN")
    return 'zh'; //统一为中文，其他都不统一
  else return lang;
  // if (lang.startsWith('zh')) return 'zh'; // 统一中文
  // if (lang.startsWith('en')) return 'en'; // 统一英文
  //return 'zh'; // 默认中文
};

// const TranslatedContent = ({ children }) => {
//   const location = useLocation(); // 获取当前路由
//   const [translatedContent, setTranslatedContent] = useState(null);

//   useEffect(() => {
//     // 读取 localStorage 中的语言，如果没有则从浏览器获取
//     let userLanguage = localStorage.getItem('userLanguage') || getBrowserLanguage();
//     localStorage.setItem('userLanguage', userLanguage); // 确保 localStorage 同步

//     console.log("当前语言为："+userLanguage)
//     if (userLanguage === 'zh') {
//       setTranslatedContent(null); // 不翻译，直接显示原始内容
//       return;
//     }
//     // 发送翻译请求
// //    const originalHTML = document.documentElement.innerHTML;
//     const originalHTML = document.body.innerHTML || "<p>No content available</p>";
//     console.log("Original HTML being sent:", originalHTML);

//     const requestData = JSON.stringify({ content: originalHTML, targetLanguage: userLanguage });
//     axios.post('/api/translate', requestData, { headers: { 'Content-Type': 'application/json' } })    
//     // axios.post('/api/translate', { content: originalHTML, targetLanguage: userLanguage })
//     //   .then(response => setTranslatedContent(response.data.translatedText))
//     //   .catch(error => console.error('Translation failed:', error));

//   }, [location]); // 当 `location` 变化时，重新翻译

//   return translatedContent ? (
//     <div dangerouslySetInnerHTML={{ __html: translatedContent }} />
//   ) : (
//     children
//   );
// };

const App = () => {
  // 动态加载 Google Translate 小部件
    
  useEffect(() => {
    const userLanguage = getBrowserLanguage(); // 获取浏览器的语言
  
    const loadGoogleTranslate = () => {
      const script = document.createElement('script');
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.onload = () => {
        if (window.google && window.google.translate) {
          window.googleTranslateElementInit = function() {
            new window.google.translate.TranslateElement({
              pageLanguage: 'zh',
              includedLanguages: 'en,zh',
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
              autoDisplay: false,
              gaTrack: true,
              multilanguagePage: true,
              defaultLanguage: userLanguage
            }, 'google_translate_element');
          };
        } else {
          console.error("Google Translate API is not loaded correctly.");
        }
      };
      script.onerror = () => {
        console.error("Failed to load Google Translate script.");
      };
      document.body.appendChild(script);
  
      return () => {
        if (script.parentNode) {
          document.body.removeChild(script);
        }
      };
    };
  
    // 延迟 500 毫秒加载
    const timeoutId = setTimeout(loadGoogleTranslate, 500);
  
    return () => {
      clearTimeout(timeoutId); // 清理定时器
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>   {/*使用 ThemeProvider 包裹 Router */}
      <BrowserRouter>
      {/* <CssBaseline /> *可选：引入 CssBaseline 重置默认样式    */}
        {/* Google Translate 按钮会显示在这个容器内 */}
        <div id="google_translate_element"></div>
        <Navigation /> {/*  将 Navigation 组件添加到页面布局 */}
        <Routes>
          <Route path="/" element={<HomePage />} /> {/* 首页 */}
          <Route path="/register" element={<RegisterPage />} /> {/* 注册页 */}
          <Route path="/login" element={<LoginPage />} /> {/* 登录页 */}
          <Route path="/auth/login" element={<LoginPage />} /> {/* 登录页 */}
          <Route path="/solutions" element={<HomePage />} /> {/* 解决方案列表 */}
          <Route path="/login" element={<LoginPage />} /> {/* 登录页 */}
          <Route path="/profile" element={<ProfilePage />} /> {/* 个人资料页路由 */}
          <Route path="/solutions/:solutionId" element={<SolutionDetailPage />} /> {/* 解决方案详情 */}
          <Route path="/subscription" element={<SubscriptionPage />} /> {/* 订阅页面路由 */}
          <Route path="/subscription-management" element={<SubscriptionManagementPage />} /> {/* 订阅管理页面路由 */}
          <Route path="/solutions/:solutionId/view" element={<SolutionDetailPage />} />  
          <Route path="/payment" element={<PaymentForm />} /> {/* 支付页 */}
          <Route path="/requirements" element={<RequirementsPage />} /> {/* Add route for RequirementsPage */}
          <Route path="/payment/alipay/return" element={<AlipayReturnPage />} /> {/* Alipay return route */}
		      <Route path="/auth/google/loading" element={<GoogleAuthLoadingPage />} /> {/*  Google loading page route */}
          <Route path="/auth/github/loading" element={<GithubAuthLoadingPage />} /> {/*  Github loading page route */}
          <Route path="/auth/google/callback" element={<LoginPage />} /> {/* Google OAuth callback route -  adjust if needed */}
          <Route path="/auth/github/callback" element={<LoginPage />} /> {/* Github OAuth callback route - adjust if needed */}
          <Route path="*" element={<NotFoundPage />} /> {/* 404 */}
        </Routes>
      </BrowserRouter>
     </ThemeProvider>
  );
};

export default App;

// import React from 'react';
// import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//     secondary: {
//       main: '#dc004e',
//     },
//   },
// });

// function TestComponent() {
//   const theme = useTheme();
//   console.log('TestComponent theme:', theme);
//   return <div>Theme is working!</div>;
// }

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <TestComponent />
//     </ThemeProvider>
//   );
// }

// export default App;
